import React, { useState } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { Chip } from '@mui/material';

import { COLOR_PRIMARY_2 } from 'src/colors';
import { NeighbourhoodDataCard } from 'src/App/HOC/Cards';
import { abbreviateNumber, convertCurrency } from 'src/utils/functions';
import { exchangeRates } from 'src/const';
import { logAmplitudeEvent } from 'src/utils/analytics';
import MapTooltipWrapper from 'src/App/HOC/Tooltips/MapTooltipWrapper';

const NeighbourhoodPointer = ({
  lat,
  lng,
  listings,
  currency,
  isUserAllowed,
  multipleMarkersCallLoading,
  handleOnSampleClick,
  scale,
  neighbourhoodObj,
  neighbourhoodAnalysisKey,
}) => {
  const matches = useMediaQuery('(max-width:550px)');
  const neighbourhoodTooltipWidth = matches ? 340 : 450;
  const neighbourhoodTooltipHeight = 300;
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);

  const icon = (
    <Chip
      label={
        neighbourhoodAnalysisKey === 'occupancy'
          ? `${neighbourhoodObj.occupancyRate}%`
          : neighbourhoodAnalysisKey === 'revenue'
          ? `${exchangeRates[currency].symbol}${abbreviateNumber(
              convertCurrency(currency, neighbourhoodObj.revenue)
            )}`
          : abbreviateNumber(neighbourhoodObj.listingCount, false)
      }
      variant="filled"
      sx={{
        minWidth: 80,
        borderColor: 'white',
        borderWidth: '1px',
        transform: `translate(-50%, -50%) scale(${scale})`,
        color: COLOR_PRIMARY_2,
        fontWeight: 500,
        '&.MuiChip-filled': {
          backgroundColor: 'white',
        },
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
      }}
      onMouseLeave={() => {
        if (!matches) {
          setTooltipOpen(false);
        }
      }}
      onTouchStart={() => {
        matches && setTooltipOpen(prev => !prev);
      }}
    />
  );

  return (
    <MapTooltipWrapper
      icon={icon}
      matches={matches}
      TooltipComponent={
        <NeighbourhoodDataCard
          listings={listings}
          currency={currency}
          width={neighbourhoodTooltipWidth}
          height={neighbourhoodTooltipHeight}
          isUserAllowed={isUserAllowed}
          multipleMarkersCallLoading={multipleMarkersCallLoading}
          handleOnSampleClick={handleOnSampleClick}
          matches={matches}
        />
      }
      handleTooltipOpen={() => {
        if (!tooltipOpen) {
          logAmplitudeEvent('heatmap_markers_hovered');
        }
        setTooltipOpen(true);
      }}
      handleTooltipClose={() => {
        if (!matches) {
          setTooltipOpen(false);
        }
      }}
      tooltipOpen={tooltipOpen}
      setTooltipOpen={setTooltipOpen}
    />
  );
};

export default React.memo(NeighbourhoodPointer);
